interface AuthConfig {
  baseUrl: string;
  redirectUrl: string;
  clientId: string;
}

interface VindiConfig {
  isSandbox: boolean;
}

interface GoogleConfig {
  recaptchaToken: string;
  analyticsMeasurementId?: string;
  adsConversionId?: string;
  adsConversionLabels?: {
    purchase?: string;
    beginCheckout?: string;
    addToCart?: string;
    addPaymentInfo?: string;
  };
}

interface FacebookConfig {
  pixelId: string;
}

export interface Environment {
  apiBaseUrl: string;
  baseUrl: string;
  instrumentsFrontendBaseUrl: string;
  feedbackBaseUrl: string;
  groupFeedbackBaseUrl: string;
  auth: AuthConfig;
  vindi: VindiConfig;
  google: GoogleConfig;
  facebook: FacebookConfig;
}

const environment: Environment = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL!,
  baseUrl: process.env.REACT_APP_BASE_URL!,
  instrumentsFrontendBaseUrl:
    process.env.REACT_APP_INSTRUMENTS_FRONTEND_BASE_URL!,
  feedbackBaseUrl: process.env.REACT_APP_FEEDBACK_BASE_URL!,
  groupFeedbackBaseUrl: process.env.REACT_APP_GROUP_FEEDBACK_BASE_URL!,
  auth: {
    baseUrl: process.env.REACT_APP_AUTH_BASE_URL!,
    redirectUrl: process.env.REACT_APP_AUTH_REDIRECT_URL!,
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID!,
  },
  vindi: {
    isSandbox: process.env.REACT_APP_VINDI_IS_SANDBOX === "true",
  },
  google: {
    recaptchaToken: process.env.REACT_APP_GOOGLE_RECAPTCHA_TOKEN!,
    analyticsMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID,
    adsConversionId: process.env.REACT_APP_GOOGLE_ADS_ID,
    adsConversionLabels: {
      purchase: process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL,
      beginCheckout: process.env.REACT_APP_GOOGLE_ADS_BEGIN_CHECKOUT_LABEL,
      addToCart: process.env.REACT_APP_GOOGLE_ADS_ADD_TO_CART_LABEL,
      addPaymentInfo: process.env.REACT_APP_GOOGLE_ADS_ADD_PAYMENT_INFO_LABEL,
    },
  },
  facebook: {
    pixelId: process.env.REACT_APP_FACEBOOK_PIXEL_ID!,
  },
};
export { environment };
